import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import GridItem from '../../components/Grid/GridItem';
import Typography from '../../components/Typography/CustomTypography';
import WrapperContainer from '../../components/Container/WrapperContainer';
import styles from '../../assets/jss/pages/errorPageStyle';

const useStyles = makeStyles(styles);

const ErrorPage = () => {
    const classes = useStyles();
    const history = useHistory();
    const intl = useIntl();
    let errorCode = 404;
    let message = intl.formatMessage({ id: 'errorPage.404' });

    if (history.location.pathname === '/403') {
        errorCode = 403;
        message = intl.formatMessage({ id: 'errorPage.403' });
    }

    return (
        <WrapperContainer className={classes.wrapper}>
            <GridItem xs={12} align="center">
                <Typography variant="h2" color="info" bold className={classes.brand}>
                    XPAND
                    <span style={{ position: 'absolute', fontSize: '70%' }}>&reg;</span>
                </Typography>
                <Typography color="success" className={classes.errorCode}>{errorCode}</Typography>
                <Typography variant="h6">{message}</Typography>
            </GridItem>
        </WrapperContainer>
    );
};

export default ErrorPage;
